module.exports = __webpack_public_path__ + "static/media/solutions__powerful_tool.250b1564.png";